<template>
  <div class="d-flex justify-content-center align-items-center py-5">
    <div class="w-100" style="max-width: 800px">
      <div class="text-center mb-5">
        <div
          class="d-inline-flex align-items-center justify-content-center rounded-circle mb-4"
          style="width: 64px; height: 64px; background: rgba(8, 145, 178, 0.1);"
        >
          <i class="fal fa-columns text-2xl" style="color: #0891B2;"></i>
        </div>
        <h2 class="text-2xl font-bold text-gray-800 mb-2">
          {{ $t('post.page.kanban.select_form_title') }}
        </h2>
        <p class="text-gray-500">
          {{ $t('post.page.kanban.select_form_description') }}
        </p>
      </div>

      <div class="kfs-grid">
        <div
          v-for="form in forms"
          :key="form.id"
          class="kfs-card"
          @click="$emit('select', form)"
        >
          <div class="kfs-card-icon">
            <i class="fal fa-poll"></i>
          </div>
          <div class="kfs-card-body">
            <h4 class="kfs-card-title">{{ form.name }}</h4>
            <p
              v-if="form.description"
              class="kfs-card-desc"
              v-html="form.description"
            ></p>
          </div>
          <div class="kfs-card-footer">
            <span class="kfs-card-action">
              <i class="fal fa-arrow-right"></i>
              {{ $t('post.page.kanban.open_kanban') }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import { mapActions, mapState } from 'vuex'

export default {
  name: 'KanbanFormSelector',
  props: {
    formTypeId: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    ...mapState('form', {
      allForms: (state) => state.forms,
    }),
    forms() {
      if (!this.allForms) return []
      if (this.formTypeId) {
        return this.allForms.filter((f) => f.form_type_id === parseInt(this.formTypeId))
      }
      return this.allForms
    }
  },
  created() {
    this.getForms().then(() => {
      if (this.forms && this.forms.length === 1) {
        this.$emit('select', this.forms[0])
      }
    })
  },
  methods: {
    ...mapActions('form', ['getForms']),
  },
}
</script>

<style scoped>
.kfs-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
}

.kfs-card {
  background: #fff;
  border: 1.5px solid #e5e7eb;
  border-radius: 14px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
}

.kfs-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.kfs-card-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(8, 145, 178, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
}

.kfs-card-icon i {
  color: #0891B2;
  font-size: 1rem;
}

.kfs-card-body {
  flex: 1;
}

.kfs-card-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 6px;
}

.kfs-card-desc {
  font-size: 0.78rem;
  color: #94a3b8;
  line-height: 1.5;
  margin: 0;
}

.kfs-card-footer {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #f1f5f9;
}

.kfs-card-action {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.82rem;
  font-weight: 600;
  color: #0891B2;
  transition: gap 0.2s;
}

.kfs-card:hover .kfs-card-action {
  gap: 12px;
}

.kfs-card-action i {
  font-size: 0.78rem;
  color: #0891B2;
}
</style>